import React, { useEffect, useState } from 'react'
import { useForm, type SubmitHandler } from 'react-hook-form'
import './edit-package.css'
import AdminButton from '../../utils/adminButton/AdminButton'
import InfoModal from '../../utils/infoModal/InfoModal'
import { type AudienceType, type PackageType } from '../../../utils/types'
import packageService from '../../../services/packageService'
import AdminDropdown from '../../utils/adminDropdown/AdminDropdown'
import audienceService from '../../../services/audienceService'
import { formatPackageData } from '../../../utils/utils'
interface EditPackageProps {
  onEditPackage: (newPackage: any) => void
  closeModal: () => void
  packageProp: Partial<PackageType>
}

const EditPackage: React.FC<EditPackageProps> = ({
  packageProp,
  onEditPackage,
  closeModal
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm<PackageType>({
    defaultValues: packageProp
  })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalText, setmodalText] = useState('')
  const [shouldCloseModal, setShouldCloseModal] = useState(false)
  const [audiences, setAudiences] = useState<AudienceType[]>([])
  const maxToWinPoints = watch('maxToWinPoints')
  const minToWinPoints = watch('minToWinPoints')

  const pointValueRequired = Boolean(maxToWinPoints || minToWinPoints)

  useEffect(() => {
    const fetchAudiences = async (): Promise<void> => {
      try {
        const response = await audienceService.getAllAudiences()
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        setAudiences(response)
      } catch (error) {
        console.error('Failed to fetch audiences:', error)
      }
    }
    void fetchAudiences()
  }, [])

  const onSubmit: SubmitHandler<PackageType> = (data: PackageType) => {
    const formatt = (str: any): number | null => {
      if (/^0+$/.test(str)) {
        return 0
      }

      return Number(str) || null
    }

    const numericMinToOrder = formatt(data.minToOrder)
    const numericMaxToOrder = formatt(data.maxToOrder)
    const numericMinToWinPoints = formatt(data.minToWinPoints)
    const numericMaxToWinPoints = formatt(data.maxToWinPoints)
    const numericPointValue = formatt(data.pointValue)
    const numericFrequencyValue = formatt(data.frequency)

    if (
      numericPointValue === 0 &&
      (numericMinToWinPoints !== 1 || numericMaxToWinPoints !== 1)
    ) {
      setmodalText(
        'Les valeurs renseignées pour les min/max points sont incohérentes'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    }

    if (
      (numericMinToOrder &&
        numericMaxToOrder &&
        numericMinToOrder > numericMaxToOrder) ||
      (numericMinToWinPoints &&
        numericMaxToWinPoints &&
        numericMinToWinPoints > numericMaxToWinPoints)
    ) {
      setmodalText(
        'Les valeurs renseignées pour les min/max packages sont incohérentes'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    }
    if (
      numericMinToWinPoints &&
      numericMinToOrder &&
      numericMinToWinPoints < numericMinToOrder &&
      numericPointValue !== 0
    ) {
      setmodalText(
        'Les valeurs renseignées pour les min/max points sont incohérentes'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    }
    if (
      numericMaxToWinPoints &&
      numericMaxToOrder &&
      numericMaxToWinPoints > numericMaxToOrder
    ) {
      setmodalText(
        'Les valeurs renseignées pour les min/max points sont incohérentes'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    }
    if (
      numericPointValue &&
      (numericMaxToWinPoints === 0 || numericMinToWinPoints === 0)
    ) {
      setmodalText(
        'Les valeurs renseignées pour les min/max points sont incohérentes'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    }
    if (
      numericPointValue &&
      (numericMaxToWinPoints === null || numericMinToWinPoints === null)
    ) {
      setmodalText(
        'Les valeurs renseignées pour les min/max points sont incohérentes'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    } if (numericFrequencyValue && numericFrequencyValue < 0) {
      setmodalText(
        'La valeur renseignée pour la fréquence est incohérente'
      )
      setIsModalOpen(true)
      setShouldCloseModal(false)
      // eslint-disable-next-line no-useless-return
      return
    } else {
      data.minToOrder = numericMinToOrder
      data.maxToOrder = numericMaxToOrder
      data.minToWinPoints = numericMinToWinPoints
      data.maxToWinPoints = numericMaxToWinPoints
      data.pointValue = numericPointValue
      data.frequency = numericFrequencyValue

      data.Audience =
        data.Audience && data.Audience.id === -1 ? null : data.Audience
      packageService
        .updatePackage(data.id, formatPackageData(data) as PackageType)
        .then((res) => {
          setmodalText('Le package a été mis à jour avec succès')
          setIsModalOpen(true)
          onEditPackage(res)
          setShouldCloseModal(true)
        })
        .catch(() => {
          setmodalText('Une erreur est survenue lors de la création du package')
          setIsModalOpen(true)
        })
    }
  }

  const allOptions = [
    { value: -1, label: '<vide>' },
    ...audiences.map((audience) => ({
      value: audience.id,
      label: audience.name
    }))
  ]

  return (
    <>
      <form className='audience-form' onSubmit={handleSubmit(onSubmit)}>
        <div className='inputs-container'>
          <div className='input-form-container'>
            <p className='input-label'>Audience</p>
            <AdminDropdown
              options={allOptions}
              placeholder='Select Audience'
              value={watch('Audience.id')}
              onChange={(value): void => {
                setValue('Audience.id', value as number)
              }}
            />
            {errors.Audience && (
              <p className='validation-error'>{errors.Audience.message}</p>
            )}
          </div>

          <div className='input-form-container'>
            <p className='input-label'>Nom Package*</p>
            <input
              className='input-text'
              {...register('label', {
                required: 'Ce champ est obligatoire'
              })}
            />
            {errors.label && (
              <p className='validation-error'>{errors.label.message}</p>
            )}
          </div>
          <div className='input-form-container'>
            <p className='input-label'>Minimum Package</p>
            <input
              className='input-text'
              {...register('minToOrder', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Les caractères saisis sont incorrects'
                },
                min: {
                  value: 0,
                  message: 'Les caractères saisis sont incorrects'
                }
              })}
            />
            {errors.minToOrder && (
              <p className='validation-error'>{errors.minToOrder.message}</p>
            )}
          </div>

          <div className='input-form-container'>
            <p className='input-label'>Maximum Package</p>
            <input
              className='input-text'
              {...register('maxToOrder', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Les caractères saisis sont incorrects'
                },
                max: { value: 999, message: 'La valeur maximale est de 999' },
                min: {
                  value: 0,
                  message: 'Les caractères saisis sont incorrects'
                }
              })}
            />
            {errors.maxToOrder && (
              <p className='validation-error'>{errors.maxToOrder.message}</p>
            )}
          </div>

          <div className='input-form-container'>
            <p className='input-label'>Point Quantité Minimum</p>
            <input
              className='input-text'
              {...register('minToWinPoints', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Les caractères saisis sont incorrects'
                },
                min: { value: 0, message: 'La valeur minimale est de 1' }
              })}
            />
            {errors.minToWinPoints && (
              <p className='validation-error'>
                {errors.minToWinPoints.message}
              </p>
            )}
          </div>

          <div className='input-form-container'>
            <p className='input-label'>Point Quantité Maximum</p>
            <input
              className='input-text'
              {...register('maxToWinPoints', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Les caractères saisis sont incorrects'
                },
                max: { value: 999, message: 'La valeur maximale est de 999' }
              })}
            />
            {errors.maxToWinPoints && (
              <p className='validation-error'>
                {errors.maxToWinPoints.message}
              </p>
            )}
          </div>

          <div className='input-form-container'>
            <p className='input-label'>Nombre de points</p>
            <input
              className='input-text'
              {...register('pointValue', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Les caractères saisis sont incorrects'
                },
                required:
                  pointValueRequired &&
                  'Ce champ est requis lorsque Point Quantité Minimum ou Point Quantité Maximum est renseigné',
                max: { value: 999, message: 'La valeur maximale est de 999' },
                min: { value: 0, message: 'La valeur minimale est de 0' }
              })}
            />
            {errors.pointValue && (
              <p className='validation-error'>{errors.pointValue.message}</p>
            )}
          </div>

          <div className='input-form-container'>
            <p className='input-label'>Fréquence Package</p>
            <input
              type='text'
              className='input-text'
              {...register('frequency', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Les caractères saisis sont incorrects'
                },
                max: { value: 999, message: 'La valeur maximale est de 999' },
                min: {
                  value: 0,
                  message: 'Les caractères saisis sont incorrects'
                }
              })}
            />
            {errors.frequency && (
              <p className='validation-error'>{errors.frequency.message}</p>
            )}
          </div>
        </div>
        <AdminButton type='submit'>Mettre à jour</AdminButton>
      </form>
      <InfoModal
        isOpen={isModalOpen}
        title='Mise à jour Package'
        message={modalText}
        onClose={() => {
          setIsModalOpen(false)
          if (shouldCloseModal) {
            closeModal()
          }
        }}
      />
    </>
  )
}

export default EditPackage
